export class RoleConst {
  public static readonly User = 1;
  public static readonly SpaceAdmin = 5;
  public static readonly UserAdmin = 10;
  public static readonly ReportAdmin = 15;
  public static readonly SuperUser = 20;
}
